export default "__VITE_ASSET__11dddd6e__"